import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FieldEditor from './FieldEditor';
import { ISections } from '@src/types/Stacks';

interface FieldSectionProps {
  section: ISections;
  sectionIndex: number;
  controlModeIndex: number;
  onFieldChange: (
    sectionIndex: number,
    fieldIndex: number,
    newValue: string | number | boolean | null,
  ) => void;
  onDeleteSection?: (sectionIndex: number) => void;
  validationErrors: Record<string, string>;
}

const FieldSection: React.FC<FieldSectionProps> = ({
  section,
  sectionIndex,
  controlModeIndex,
  onFieldChange,
  onDeleteSection,
  validationErrors,
}) => {
  return (
    <Box
      sx={{
        mb: 4,
        mt: 1,
        p: 2,
        bgcolor: 'rgba(0, 0, 0, 0.1)',
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
          {section.uiLabel}
        </Typography>
        {onDeleteSection && (
          <IconButton
            onClick={() => onDeleteSection(sectionIndex)}
            size='small'
            title='Delete section'
            aria-label='Delete section'
            sx={{
              opacity: 0.4,
            }}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
      {section.fields.map((field, fieldIndex) => (
        <Box key={fieldIndex} sx={{ mb: 2, mt: 1 }}>
          <FieldEditor
            field={field}
            onChange={(newValue) =>
              onFieldChange(sectionIndex, fieldIndex, newValue)
            }
            errorKey={`controlMode_${controlModeIndex}_section_${sectionIndex}_field_${fieldIndex}`}
            validationErrors={validationErrors}
          />
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(FieldSection);
